<!---->
<template>
  <el-form-item
    ref="formitem"
    :label="label"
    v-bind="$attrs"
    :prop="prop"
    class="rt-form-item-wrapper"
  >
    <span v-if="!label" slot="label"></span> <slot />
  </el-form-item>
</template>

<script>
const methods = ['resetField', 'clearValidate'];

function is_all_ws(nod) {
  return !/[^\t\n\r ]/.test(nod.data);
}

function is_ignorable(node) {
  return (
    node.nodeType == 8 || // 注释节点
    (node.nodeType == 3 && is_all_ws(nod))
  ); // 仅含空白符的文字节点
}
function node_after(sib) {
  while (sib && (sib = sib.nextSibling)) {
    if (!is_ignorable(sib)) return sib;
  }
  return null;
}

export default {
  name: 'RtFormItem',
  props: {
    label: String,
    prop: String
  },
  mounted() {
    this.$nextTick(() => {
      // 将 elementui formItem 组件原生方法附加在 rtFromItem 上面
      methods.map(method => {
        this[method] = this.$refs.formitem[method];
      });

      // 在 input 后面追加一个 div，用来实现输入框阴影效果
      let $input =
        this.$el.querySelector('input.el-input__inner') ||
        this.$el.querySelector('textarea.el-textarea__inner');
      let refrenceNode = node_after($input);

      if ($input && $input.parentElement) {
        // 获取父节点
        let $parent = $input.parentElement;
        // 构建 box-shadow 节点
        let shadowNode = document.createElement('div');
        shadowNode.classList.add('rt-input-shadow');
        $parent.insertBefore(shadowNode, refrenceNode);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// rtFormItem.vue?0db3c197